<template>
  <div class="item-detail">
      <div class="item-detail-left">
        <div class="item-detail-left-time">{{item.config.time}}</div>
        <img :src="`http://tarzan.minus.live${item.img}`"/>
      </div>
      <div class="item-detail-right">
        <div class="item-detail-right-title" >{{item.name}}</div>
        <pre class="item-detail-right-new" >
          {{item.config.content}}
        </pre>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object
    }
  }
}
</script>

<style lang="less">
  .item-detail{
      position: relative;
      padding: 30px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #999;
      @media (min-width: 1280px) and (max-width: 1680px){
        padding: 45px 0px;
      }
            
      @media screen and (min-width: 1920px){
        padding: 60px 0px;
      }
      &-left {
        img {
          width: 222px;
          height: auto;
          transform-origin: 50% 50%;
          transition: all .5s ease-in-out;
        }

        @media (min-width: 1280px) and (max-width: 1680px){
          width: 333px;
        }
              
        @media screen and (min-width: 1920px){
          width: 444px;
        }

        &-time {
          color: #999;
          margin-bottom: 30px;
          font-size: 10px;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 15px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 20px;
          }
        }
      }

      &-right {
        width: 600px;
        margin-left: 10px;
        padding: 0 30px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        @media (min-width: 1280px) and (max-width: 1680px){
          width: 900px;
          padding: 0px 45px;
          margin-left: 15px;
        }
              
        @media screen and (min-width: 1920px){
          width: 1200px;
          padding: 0px 60px;
          margin-left: 20px;
        }

        &-title {
          color: #444;
          margin-bottom: 30px;
          font-size: 16px;
          font-weight: 200;
          cursor: pointer;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 24px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 32px;
          }
        }

        &-new {
          font-size: 10px;
          color: #444;
          text-align: left;
          white-space: pre-wrap;
          line-height: 2;

          @media (min-width: 1280px) and (max-width: 1680px){
            font-size: 15px;
          }
                
          @media screen and (min-width: 1920px){
            font-size: 20px;
          }
        }
      }
    }
</style>